import { IValidationFormTracking } from './interfaces';

export const ValidationFormTracking = ({
  track,
  phone,
  setErrorTrack,
  setErrorPhone,
}: IValidationFormTracking) => {
  let err = 0;

  if (track.length === 0) {
    setErrorTrack('Пожалуйста, заполните поле');
    err = 1;
  }

  if (phone === '+7 (___) ___-__-__') {
    setErrorPhone('Пожалуйста, заполните поле');
    err = 1;
  }

  if (err) {
    return false;
  }

  setErrorTrack(null);
  setErrorPhone(null);
  return true;
};

export const GetDeliveryService = (office: string) => {
  const isDalliOffice = office.toLowerCase().includes('офис');
  const isDalliSpb = office.toLowerCase().includes('дс-спб');
  const idCdek = office.toLowerCase().includes('сдэк');

  if (isDalliOffice || isDalliSpb) {
    return 'DALLI';
  }

  if (idCdek) {
    return 'CDEK';
  }

  return office;
};
